import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { browserHistory } from 'react-router';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { cyan900, cyan500 } from 'material-ui/styles/colors';
import DialogModal from '../home/DialogModal';
import _ from 'lodash';

const propTypes = {
  optiongroup: PropTypes.any,
  onSave: PropTypes.func,
  onDelete: PropTypes.func,
  onView: PropTypes.func,
};

class EditOptionGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogTitle: ' ',
      dialogMessage: ' ',
      dialogActionTitle: ' ',
      required: {
        name: null,
      },
      optiongroup: {
        name: '',
      },
      open: false,
      edited: false,
      viewRedirect: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    let optiongroup = nextProps.optiongroup;
    if (nextProps.optiongroup.id) {
      optiongroup = nextProps.optiongroup;
    }
    optiongroup.id = (optiongroup.id === null) ? '0' : optiongroup.id;
    this.setState({ optiongroup });
    this.setRequiredParams();
  }
  setRequiredParams() {
    const required = this.state.required;
    const optiongroup = this.state.optiongroup;
    Object.keys(this.state.required).forEach((paramName) => {
      const param = optiongroup[paramName];
      required[paramName] = (param == null || param.length === 0 || param === 0) ? 'This field is required' : null;
    });
    this.setState({ required });
  }
  handleChange(e) {
    const optiongroup = this.props.optiongroup;
    if (e.target.type === 'checkbox') {
      _.set(optiongroup, e.target.name, e.target.checked);
    } else {
      _.set(optiongroup, e.target.name, e.target.value);
    }
    this.setState({
      optiongroup,
      edited: true,
    });
    this.setRequiredParams();
  }
  handleDeleteOpen() {
    const nextState = this.state;
    nextState.dialogTitle = 'Delete Option Group';
    nextState.dialogMessage = 'Do you really want to delete this option group?';
    nextState.dialogActionTitle = 'Delete';
    nextState.open = true;
    nextState.delete = true;
    this.setState({ nextState });
  }
  navigateToView() {
    if (this.state.edited === true) {
      const nextState = this.state;
      nextState.viewRedirect = true;
      this.setState(nextState);
      this.handleOpen();
    } else {
      browserHistory.push(`/optiongroups/view/${this.props.optiongroup.id}`);
    }
  }
  handleClose() {
    this.setState({
      open: false,
      edited: false,
      viewRedirect: false,
    });
    if (this.state.viewRedirect) {
      browserHistory.push(`/optiongroups/view/${this.props.optiongroup.id}`);
    }
  }
  handleOpen() {
    const nextState = this.state;
    nextState.dialogTitle = 'Save Option Group Changes';
    nextState.dialogMessage = 'Do you really want to save the changes to this option group?';
    nextState.dialogActionTitle = 'Save';
    nextState.open = true;
    this.setState({ nextState });
  }
  saveChanges() {
    this.setState({
      open: false,
      edited: false,
      viewRedirect: false,
    });
    switch (true) {
      case (this.state.delete):
        this.props.onDelete(this.props.optiongroup.id);
        break;
      case (this.state.edited && this.state.viewRedirect):
        this.props.onView(this.state.optiongroup);
        break;
      default:
        this.props.onSave(this.state.optiongroup);
        break;
    }
  }
  handleCancel() {
    browserHistory.push('/optiongroups?page=1');
  }
  render() {
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '1%',
      },
    };
    return (
      <div>
        <div>
          <DialogModal
            dialogOpen={this.state.open}
            dialogHandleClose={this.handleClose}
            dialogHandleSubmit={() => this.saveChanges()}
            dialogTitle={this.state.dialogTitle}
            dialogMessage={this.state.dialogMessage}
            dialogActionTitle={this.state.dialogActionTitle}
          />
          <div className="float-right">
            <RaisedButton
              label="Cancel"
              style={{ marginRight: '10px' }}
              primary
              onClick={this.handleCancel}
            />
            <RaisedButton
              style={{ marginRight: '10px' }}
              label="View"
              primary
              onClick={this.navigateToView}
            />
            <RaisedButton
              style={{ marginRight: '10px' }}
              label="Delete"
              primary
              onClick={this.handleDeleteOpen}
            />
            <RaisedButton
              label="Save"
              primary
              onClick={this.handleOpen}
            />
          </div>
          <br />
          <TextField
            floatingLabelText="ID"
            floatingLabelStyle={styles.floatingLabelStyle}
            inputStyle={styles.inputStyle}
            value={this.props.optiongroup.id}
            disabled
          />
          <br />
          <TextField
            floatingLabelText="Name"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.optiongroup.name}
            name="name"
            onChange={this.handleChange}
            errorText={this.state.required.name}
            errorStyle={{ color: cyan500 }}
          />
        </div>
      </div>
    );
  }
}

EditOptionGroup.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

EditOptionGroup.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    optiongroup: state.optiongroups.optiongroup,
    optiongroups: state.optiongroups,
  };
}

export default connect(mapStateToProps)(EditOptionGroup);



// WEBPACK FOOTER //
// ./src/components/optiongroups/EditOptionGroup.js